// @ts-nocheck

import { reduce, difference } from 'lodash';
import memoize from 'memoize-state';

import { selectEntitiesBetslips } from '../../selectors/entities/betslips/entitiesBetslipsPrimary.selector';
import { selectNetwork } from '../../selectors/network/networkPrimary.selector';
import {
  selectUserEmbeddedNotificationTarget,
  selectUserLastSessionSettledBets,
} from '../../selectors/user/userPrimary.selector';
import { BetslipStatus } from '../../types/history';
import { NetworkStatuses } from '../../types/network';

export default memoize((state) => {
  const betslips = selectEntitiesBetslips(state);
  const lastSessionSettledBets = selectUserLastSessionSettledBets(state);
  const embeddedNotificationTarget = selectUserEmbeddedNotificationTarget(state);
  const networkStatus = selectNetwork(state);

  // if user came from notification to history, we don't want to display WinModal
  const fromEmbedNotificationToHistory =
    embeddedNotificationTarget &&
    embeddedNotificationTarget !== '' &&
    (embeddedNotificationTarget === 'history' ||
      embeddedNotificationTarget.match(/^history-([A-Z0-9]{5}-[A-Z0-9]{8}(-[0-9]*)?)/i));

  let shouldClearLastSessionsSettledBets = fromEmbedNotificationToHistory && lastSessionSettledBets.length > 0;

  let betslipReferencesToFetch: Array<string> = [];
  let shouldOpen: boolean = false;
  let betslipIds: Array<number> = [];

  if (lastSessionSettledBets.length > 0 && !fromEmbedNotificationToHistory) {
    const storedBetslips = reduce(
      betslips,
      (acc, cur) => (lastSessionSettledBets.indexOf(cur.betslipReference) !== -1 ? [...acc, cur] : acc),
      [],
    );

    betslipIds = storedBetslips.map((b) => b.betslipId);
    if (networkStatus === NetworkStatuses.CONNECTED) {
      const storedBetslipReferences = storedBetslips.map((betslip) => betslip.betslipReference);
      betslipReferencesToFetch = difference(lastSessionSettledBets, storedBetslipReferences);
    }

    // all betslips are fetch
    if (
      !shouldClearLastSessionsSettledBets &&
      betslipReferencesToFetch.length === 0 &&
      lastSessionSettledBets.length === betslipIds.length
    ) {
      const relatedBetslips = betslipIds.reduce((acc, cur) => [...acc, betslips[cur]], []);
      const hasOnlyWinningAndCancelledBets = relatedBetslips.reduce((acc, cur) => {
        const isWinOrCancel =
          (cur.status === BetslipStatus.SETTLED && cur.winningsAmount > 0) || cur.status === BetslipStatus.CANCELLED;
        return acc && isWinOrCancel ? true : false;
      }, true);
      // if we have betslips with incorrect status, we clear all
      shouldClearLastSessionsSettledBets = !hasOnlyWinningAndCancelledBets;
      shouldOpen = hasOnlyWinningAndCancelledBets;
    }
  }

  return {
    betslipReferencesToFetch,
    shouldOpen,
    shouldClearLastSessionsSettledBets,
    betslipIds,
  };
});
